import React, { useContext, useState } from 'react'
import { UserContext } from '../../App'
import { useNavigate } from 'react-router-dom'

export default function DMain() {

  const navigate = useNavigate()
  const { user } = useContext(UserContext)

  return (
    <div className="h-full">
    </div>
  )
}